<template>
    <div v-if="!hide"  class="form-network form-network-threads">
        <details v-if="formData.urlsTextContentHistory.length" open>
            <summary>{{ $t('dash.post-creator.form.link-preview') }} <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail form-link">
                <p v-if="formData.urlsTextContent.length" class="previewLinkDisabled"><i class="fa-regular fa-circle-exclamation"></i>{{ $t('dash.post-creator.form.threads.link-in-content') }}</p>
                <div class="list-thubmmail" :class="{disabled : formData.urlsTextContent.length}">
                    <div class="thubmmail" v-for="(url) in this.formData.urlsTextContentHistory" @click="()=>selectUrl(url)" :key="url">
                        <Checkbox :id="url" :prefixId="'thubmmail-'" 
                            :isChecked="(formDataNetwork.snippet.link == url && !formData.urlsTextContent.length)" 
                            :isDisable="(formDataNetwork.snippet.link == url || formData.urlsTextContent.length)"
                            :add="selectUrl" :remove="()=>{}">
                        </Checkbox>
                        <SnippetNetwork 
                            :link="url"
                            :imageUrlDefault="!inputModel.switchCustomSnippet || inputModel.titleSnippet || inputModel.descriptionSnippet ? undefined : inputModel.urlImageSnippet" 
                            :titleDefault="inputModel.switchCustomSnippet ? inputModel.titleSnippet : undefined" 
                            :descriptionDefault="inputModel.switchCustomSnippet ? inputModel.descriptionSnippet : undefined">
                        </SnippetNetwork>
                    </div>
                </div>
            </div>
        </details>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import store from '@/store/index.js';
    import ComponentSwitch from '@/components/dash/utils/switch.vue'
    import SnippetNetwork from './../SnippetNetwork.vue'
    import minxinBot from '@/components/mixins/Bots.vue'
    import minxinPost from '@/components/mixins/Posts.vue'
    import Checkbox from '@/components/dash/utils/checkbox.vue'

    export default {

        components: {
            ComponentSwitch,
            SnippetNetwork,
            Checkbox
        },
        mixins: [minxinBot,minxinPost],

        props: {
            hide : {
                type: Boolean,
                default: false
            },
            formData: {
                type: Object,
                default: () => ({})
            },
            formDataNetwork: {
                type: Object,
                default: () => ({})
            },

           
        },
        
        data() {
            return {
                inputModel:{
                    switchCustomSnippet: false,
                },

          
    
                lastModeSelected : undefined
            }
        },

        created () {

        },

        mounted() {
            if (this.formData.formDataNetwork.threads) this.formDataNetwork = this.formData.formDataNetwork.threads
        },

        methods: {
            addMode(mode) {
                this.lastModeSelected = mode
                EventBus.$emit("postCreatorAddMode", mode);
            },

            selectTypeContent(typeContent = '') {
                this.formDataNetwork.typeContent = this.formDataNetwork.typeContent == typeContent ? '' : typeContent
                this.$emit('setFormDataNetwork', 'threads', this.formDataNetwork)
            },


            selectUrl(url) {
        
                if (!this.formDataNetwork.snippet) this.formDataNetwork.snippet = {}
                this.formDataNetwork.snippet.link = this.formDataNetwork.snippet.link == url ? '' : url
                this.$emit('setFormDataNetwork', 'threads', this.formDataNetwork)
            },


            verifUrlSelected() {


                if (this.formData.urlsTextContentHistory.length) {
                    let linkSelect = this.formDataNetwork && this.formDataNetwork.snippet && this.formDataNetwork.snippet.link ? this.formDataNetwork.snippet.link : null
                    if (linkSelect && !this.formData.urlsTextContentHistory.includes(linkSelect)) {
                        this.selectUrl('')
                    }
                }else{
                    this.selectUrl('')
                }
             
            },

            detectTypeContent() {
                if(this.formData.files.length) { 
                    if((this.formDataNetwork.typeContent !== 'link' || !this.formDataNetwork.snippet.link)) {

                        let file = this.formData.files.find(file => ['video','image'].includes(file.type2))
                        if (file) {
                            this.formDataNetwork.typeContent = 'media'
                            this.$emit('setFormDataNetwork', 'threads', this.formDataNetwork)
                        }
                    }
                }
            },
          
        },


       

        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },
        },

        watch: {
            ['formData.formDataNetwork.threads']() {
                if (this.formData.formDataNetwork.threads) this.formDataNetwork = this.formData.formDataNetwork.threads
            },

            'formData.urlsTextContentHistory'(newValue) {
                this.verifUrlSelected()
            },
            'formData.files'(newValue) {
                this.detectTypeContent()
            }

        },


        beforeDestroy () {
        
        }
        
    }
</script>